import React, { useState,useEffect,useMemo } from "react";
import { useDispatch } from "react-redux";
import {Typography,Box,Grid,Button,InputLabel,Select,OutlinedInput,MenuItem,FormControl} from "@mui/material";
import Moment from "moment";
import formatPhoneNumber from "../../../../Components/Formats/PhoneNumberValidation";
import MaterialReactTable from 'material-react-table';
import { postData } from "../../../../redux/apiSlice";
import { ExportToCsv } from 'export-to-csv'; 
import { DateRangePicker,createStaticRanges } from 'react-date-range';
import { calendarFilter,useDateSelectionRange } from '../../../../Components/CommonFormula';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import config from '../../../../AppConfig';

const ReferralTab = ({ company_id,handleFreezStart,handleFreezStop,loginUser}) => {
    const dispatch = useDispatch();
    const [userinfo, setUserInfo] = useState([]);
    const { selectionRange, setSelectionRange, startDate, endDate,clearFilter } = useDateSelectionRange();
    const [rowSelection, setRowSelection] = useState({});
    const [columnVisibility, setColumnVisibility] = React.useState({});
    const sideBar = calendarFilter();
    const staticRanges = [
        // ...defaultStaticRanges,
        ...createStaticRanges(sideBar)
    ];
    const GetReferalinfo = async () => {
        handleFreezStart();
        let apiUrl;
        if(loginUser.roles_id  <= 2) {
          apiUrl = '/fetchReferralInfo/admin/'+ company_id;
        }else{
            apiUrl = '/fetchReferralInfo';
        }
        const args = {
            fromDate: startDate,
            toDate: endDate
        }
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            if (res.success == true) {
                handleFreezStop();
                setUserInfo(res.data.refferedCompany);
            } else {
                handleFreezStop();
            }
        }
    }
    useEffect(() => {
        GetReferalinfo();
    }, []);

  const columns = useMemo(
    //column definitions...
    () => [
      {
        accessorFn: (data) => `${data.company_name} `,
        id: "company_name",
        header: "Referred Affiliate",
        size: 150,
        Cell: ({ renderedCellValue, data }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <span>{renderedCellValue}</span>
          </Box>
        ),
      },
      {
        accessorFn: (data) => `${data.first_name + " " + data.last_name}`,
        id: "name",
        header: "Name",
        size: 150,
        Cell: ({ renderedCellValue, data }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <span>{renderedCellValue}</span>
          </Box>
        ),
      },
      {
        accessorFn: (data) => `${data.email ? data.email.trim() : ""}`, 
        enableClickToCopy: true,
        id: "email",
        header: "Email Address",
        size: 200,
        Cell: ({ renderedCellValue, row }) =>
          row.original.email ? row.original.email.trim() : "N/A",
      },
      {
        accessorFn: (data) => `${data.phone_no}`,
        filterVariant: "range",
        id: "phoneNo",
        header: "Phone no.",
        size: 50,
        Cell: ({ renderedCellValue, row }) =>
          row.original.phone_no
            ? formatPhoneNumber(row.original.phone_no)
            : "N/A",
      },
      {
        accessorFn: (data) =>
          `${data.referral_enrolled_date ? data.referral_enrolled_date : ""}`,
        filterVariant: "range",
        id: "referral_enrolled_date",
        header: "Enrolled Date",
        size: 100,
        Cell: ({ renderedCellValue, row }) => (
          <div>
            {row.original.referral_enrolled_date
              ? Moment(row.original.referral_enrolled_date).format("MM-DD-YYYY")
              : "N/A"}
          </div>
        ),
      },
      {
        accessorFn: (data) => `${data.pandadoc_id ? data.pandadoc_id : ""}`,
        accessorKey: "docId",
        filterVariant: "range",
        id: "docId",
        header: "Agreement ID",
        size: 150,
        Cell: ({ renderedCellValue, row }) => (
          <>
            {row.original.pandadoc_id ? (
              <span>{row.original.pandadoc_id}</span>
            ) : (
              "N/A"
            )}
          </>
        ),
      },

      {
        accessorFn: (data) => `${data.reference_affiliate_status_master_id}`,
        accessorKey: "company_status",
        filterVariant: "range",
        id: "company_status",
        header: "Status",
        size: 150,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Typography>
              {row.original.reference_affiliate_status_master_id == 1
                ? "Application Submitted"
                : row.original.reference_affiliate_status_master_id == 2
                ? "Agreement Generated"
                : row.original.reference_affiliate_status_master_id == 3
                ? "Agreement Signed"
                : row.original.reference_affiliate_status_master_id == 4
                ? "Approved"
                : row.original.reference_affiliate_status_master_id == 5
                ? "Completed"
                : "NA"}
            </Typography>
          </>
        ),
      },

      {
        accessorFn: (data) => `${data.referralCount}`,
        accessorKey: "referralCount",
        filterVariant: "range",
        id: "referralCount",
        header: "Total Enrollments",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (row.original.referralCount),
      },
      {
        accessorFn: (data) => `${data.referralCount}`,
        accessorKey: "activeEnroledCount",
        filterVariant: "range",
        id: "activeEnroledCount",
        header: "Active Enrollments",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (row.original.activeEnrolledCount),
      },
    ]
  );

  //csv start here
  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    fileName: "Referral-Program",
    headers: [
      "Referred Affiliate",
      "Name",
      "Email Address",
      "Phone no.",
      "Enrolled Date",
      "View Document",
      "Aid List",
      "Status",
      "Total Enrollments",
      "Active Enrollments",
    ],
  };

  const csvExporter = new ExportToCsv(csvOptions);
  const handleExportData = (userinfo) => {
    const exportedData = userinfo.map((row) => {
      let status;
      switch (row.original.reference_affiliate_status_master_id) {
        case 1:
          status = "Application Submitted";
          break;
        case 2:
          status = "Agreement Generated";
          break;
        case 3:
          status = "Agreement Signed";
          break;
        case 4:
          status = "Approved";
          break;
        case 5:
          status = "Completed";
          break;
        default:
          status = "NA";
      }
      return {
        company_name: `${row.original.company_name} `,
        name: `${row.original.first_name + " " + row.original.last_name}`,
        email: `${row.original.email} `,
        phoneNo: `${formatPhoneNumber(row.original.phone_no)}`,
        referral_enrolled_date: `${row.original.referral_enrolled_date}`,
        docId: `${row.original.pandadoc_id}`,
        aidList: `${
          row.original.aidList !== undefined &&
          row.original.aidList !== null &&
          row.original.aidList.length > 0
            ? row.original.aidList.join(", ")
            : "N/A"
        }`,
        Status: status,
        "Total Enrollments": `${row.original.referralCount}`,
        "Active Enrollments": `${row.original.activeEnrolledCount}`,
      };
    });
    const csvContent = convertToCSV(exportedData);
    // Create a Blob object from the CSV data
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });

    // Create a download link element
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = csvOptions.fileName + ".csv";

    // Append the link to the document body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the file download
    link.click();

    // Clean up the temporary URL and remove the link from the document
    URL.revokeObjectURL(link.href);
    link.remove();
  };

  const convertToCSV = (data) => {
    const headers = csvOptions.headers.join(",") + "\n";

    const rows = data
      .map((row) => {
        return Object.values(row)
          .map((value) => {
            // Wrap the value with double quotes if it contains a comma
            if (typeof value === "string" && value.includes(",")) {
              return `"${value}"`;
            }
            return value;
          })
          .join(",");
      })
      .join("\n");

    return headers + rows;
  };

  return (
    <>
      <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1}>
        <Grid item lg={4} md={4} sm={6} xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-multiple-name-label">
              Select Date Range
            </InputLabel>
            <Select
              labelId="demo-multiple-name-label"
              id="demo-multiple-name"
              value="date"
              input={<OutlinedInput label="Select Date Range" />}
            >
              <MenuItem value="date">
                {startDate ? (
                  <>
                    {startDate} To {endDate}
                  </>
                ) : (
                  "Select Date Range"
                )}
              </MenuItem>
              <DateRangePicker
                className="custom-date-picker"
                onChange={(item) => setSelectionRange([item.selection])}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                ranges={selectionRange}
                direction="horizontal"
                maxDate={new Date()}
                staticRanges={staticRanges}
              />
            </Select>
            <Button onClick={clearFilter}>Clear Dates</Button>
          </FormControl>
        </Grid>
        <Grid item lg={8} md={8} sm={6} xs={6}>
          <Button
            variant="contained"
            color="success"
            sx={{ minWidth: 200 }}
            onClick={GetReferalinfo}
          >
            {" "}
            Submit
          </Button>
        </Grid>
      </Grid>
      <MaterialReactTable
        columns={columns}
        data={userinfo}
        enableColumnFilterModes
        filterFns={{
          customSearchFilterFn: (row, id, filterValue) =>
            row
              .getValue(id)
              .toLowerCase()
              .replace(/\s/g, "")
              .includes(filterValue.toLowerCase().replace(/\s/g, "")),
        }}
        globalFilterFn="customSearchFilterFn" //exact serach filter functionality
        enableColumnOrdering={false}
        enableRowSelection={false}
        getRowId={(row) => row.id} //give each row a more useful id
        onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
        state={{ columnVisibility, rowSelection }} //pass our managed row selection state to the table to use
        initialState={{
          showColumnFilters: false,
          density: "compact",
        }}
        onColumnVisibilityChange={(state) => {
          setColumnVisibility(state);
        }}
        enableColumnFilters={config.DatatableColumnFilter}
        positionToolbarAlertBanner="bottom"
        enableDensityToggle={false}
        muiTablePaperProps={{
            sx: { backgroundColor: "white" },
        }}
        muiTableHeadCellProps={{
            sx: {
                backgroundColor: "#2A68B3",
                color: "white",
                fontWeight: "bold",
            },
        }}
        muiTableBodyRowProps={({ row }) => ({
            sx: { backgroundColor: row.index % 2 === 0 ? "white" : "#EBF4FF" },
        })}
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            sx={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}
          >
            <Button
              sx={{ bgColor: "#2A68B3" }}
              disabled={table.getPrePaginationRowModel().rows.length === 0}
              //export all rows, including from the next page, (still respects filtering and sorting)
              onClick={() =>
                handleExportData(table.getPrePaginationRowModel().rows)
              }
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              CSV
            </Button>
          </Box>
        )}
      />
    </>
  );
};

export default ReferralTab;
